export default {
  'admin': 'Admin',
  'users': 'Users',
  'assets': 'Assets',
};